"use client";

import { faShareNodes } from '@fortawesome/pro-regular-svg-icons/faShareNodes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ShareButton = ({ title = 'Check this out!', text, darkIcon = false }: { title?: string, text: string, darkIcon?: boolean }) => {

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title,
          text,
          url: window.location.href,
        });
      } else {
        // console.log('Web Share API not supported in this browser.');
      }
    } catch (error) {
      console.error('Error sharing content:', error);
    }
  };
  return (
    <button aria-label="Favourite button"
      onClick={handleShare}
    >
      <FontAwesomeIcon icon={faShareNodes} className={`h-6 flex items-center justify-center ${darkIcon ? "text-neutral-700" : "text-white"} w-full `} />
    </button>
  );
};

export default ShareButton;
